import type { ReactNode } from "react";
import { Link } from "react-router-dom";

/**
 * Top frame for every page on portal.example.com.
 *
 * Mirrors the staff brand language — black backdrop, chrome-silver
 * wordmark, faint crimson radial vignette — but no sidebar, no
 * operator chrome, no dense topbar. Used by every Portal* page so
 * the header reads consistently across the client experience.
 */
export function PortalShell({
  children,
  narrow,
  actions,
}: {
  children: ReactNode;
  /** Login/Sent/Verify use a tight, centered card layout. */
  narrow?: boolean;
  /** Right-side topbar actions, e.g. "Sign out" on authed pages. */
  actions?: ReactNode;
}) {
  return (
    <div className="portal-shell">
      <header className="portal-topbar">
        <Link to="/portal/dashboard" className="portal-wordmark" aria-label="Alief Funding Hub — Client Portal">
          <img src="/brand-logo.png" alt="" aria-hidden="true" />
          <div className="portal-wordmark-text">
            <strong>Alief Funding Hub</strong>
            <span>Client Portal</span>
          </div>
        </Link>
        {actions && <div className="portal-topbar-actions">{actions}</div>}
      </header>
      <main className={narrow ? "portal-main narrow" : "portal-main"}>{children}</main>
    </div>
  );
}
